import {CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {JwtParserService} from './services/jwt-parser.service';
import {ModalService} from './services/modal.service';
import {AuthGuard} from './services/auth.guard';
import {RouterModule} from '@angular/router';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor} from './services/interceptor/api.interceptor';
import {TooltipModalComponent} from './components/tooltip-modal/tooltip-modal.component';
import {ToasterComponent} from './components/toaster/toaster/toaster.component';
import {LeftNavigationComponent} from './components/left-navigation/left-navigation.component';
import {TrimStr} from './pipes/trim.pipe';
import {MaskCardPipe} from './pipes/mask-card.pipe';
import {DomSanitizerPipe} from './pipes/dom-sanitizer.pipe';
import {PointsModalComponent} from './components/points-reward-modal/points-modal.component';
import {PointsChildModalComponent} from './components/points-reward-modal/points-child-modal.component';
import {PointsModalService} from "./services/points-modal.service";
import {BannerUnitComponent} from "./components/banner-unit/banner-unit.component";
import { ZoneComponent } from './components/zone/zone.component';
import { RichtextComponent } from './components/zone-component/richtext/richtext.component';
import { ChevronCtasParentComponent } from './components/zone-component/chevron-ctas-parent/chevron-ctas-parent.component';
import { GuestUserCtaComponent } from './components/zone-component/chevron-ctas-parent/guest-user-cta/guest-user-cta.component';
import { LinkingInProgressCtaComponent } from './components/zone-component/chevron-ctas-parent/linking-in-progress-cta/linking-in-progress-cta.component';
import { LinkAccountCtaComponent } from './components/zone-component/chevron-ctas-parent/link-account-cta/link-account-cta.component';
import { CobrandCtasParentComponent } from './components/zone-component/cobrand-ctas-parent/cobrand-ctas-parent.component';
import { LoaderCtaComponent } from './components/zone-component/chevron-ctas-parent/loader-cta/loader-cta.component';
import { UnlinkAccountCtaComponent } from './components/zone-component/chevron-ctas-parent/unlink-account-cta/unlink-account-cta.component';
import { ChevronToastComponent } from './components/zone-component/chevron-ctas-parent/chevron-toast/chevron-toast.component';


@NgModule({
    declarations: [
        TooltipModalComponent,
        ToasterComponent,
        LeftNavigationComponent,
        PointsChildModalComponent,
        PointsModalComponent,
        TrimStr,
        MaskCardPipe,
        DomSanitizerPipe,
        BannerUnitComponent,
        ZoneComponent,
        RichtextComponent,
        ChevronCtasParentComponent,
        GuestUserCtaComponent,
        LinkAccountCtaComponent,
        LinkingInProgressCtaComponent,
        LoaderCtaComponent,
        UnlinkAccountCtaComponent,
        ChevronToastComponent,
        CobrandCtasParentComponent,
        LoaderCtaComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ReactiveFormsModule,
        ModalModule.forRoot(),
    ],
    exports: [TooltipModalComponent, ToasterComponent, LeftNavigationComponent, PointsChildModalComponent, PointsModalComponent, BannerUnitComponent, TrimStr,
        MaskCardPipe,
        DomSanitizerPipe, CommonModule, FormsModule, ReactiveFormsModule, ModalModule, ZoneComponent, RichtextComponent],
    providers: [
        JwtParserService,
        PointsModalService,
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        ModalService,
    ],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA], // required for svg custom properties
})
@Injectable()
export class SharedModule {
}
